import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./utils/redux";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#4E4848",
      light: "#B48F19",
      // contrastText:'#000000'
    },
    secondary: {
      main: "#EFEAE2",
      light: "#F9F7F2",
      dark: "#D9BB7F",
      contrastText: "#000000",
    },
  },
  typography: {
    fontFamily: ["Sen"].join(","),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StyledEngineProvider injectFirst>
    <CssBaseline />
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router basename="/">
          <App />
        </Router>
      </ThemeProvider>
    </Provider>
  </StyledEngineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
